export default __webpack_public_path__ + "static/media/Complete-Oral.64a96698.png";